export const en = {
  message: '🎉 New designs for Passover, sign up now to get 10% off your first purchase'
}; 